<template>
  <div class="p-login">
    <div class="p-login__form">
      <img
        class="p-login__form__logo"
        :alt="$t('functional.signableLogo')"
        src="../../assets/signable_cropped.svg"
      />
      <a
        href="#"
        @click.prevent="goAuth"
        id="login-with-google-button">
        <img
          alt="Login with Google"
          src="../../assets/btn_google_signin_dark_normal_web@2x.png"
        />
      </a>
      <Transition name="fade">
        <TWLoadingSpinner v-if="loading" />
      </Transition>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import TWLoadingSpinner from '@/components/tailwind/LoadingSpinner.vue';
import HTTP from '@/utils/http';

export default {
  name: 'AdminLogin',
  components: {
    TWLoadingSpinner,
  },
  data() {
    return {
      loading: true,
    };
  },
  async mounted() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const code = urlSearchParams.get('code');
    const user = urlSearchParams.get('user');

    // If there is no user or code in the URL then redirect to the Envelopes page
    if (!user && !code) {
      window.location = '/envelopes';
    }

    // If there is a user then set the user ID in session storage for later usage
    if (user) {
      sessionStorage.setItem('user', user);
    }

    if (code) {
      const userId = sessionStorage.getItem('user');
      // get rid of code in url to prevent repeats
      window.history.replaceState({}, document.title, `${window.location.pathname}?user=${userId}`);
      await this.exchangeCodeForToken(code);
    }

    this.loading = false;
  },
  methods: {
    ...mapActions({
      setAccessToken: 'auth/SET_ACCESS_TOKEN',
    }),
    async goAuth() {
        try {
            this.loading = true;
            const loginUrl = await this.getLoginUrl();
            if (loginUrl) {
              window.location = loginUrl;
            }
        } catch (e) {
          // eslint-disable-next-line
          console.error(e);
          this.$bus.$emit('renderGlobalMessage', {
            message: e.message,
            type: 'error',
            title: 'Error!!!',
          });
          this.loading = false;
        }
    },
    getLoginUrl() {
      return HTTP({
          url: 'admin/auth/redirect',
          auth: false,
        })
        .then(response => response.data.data.redirect_url)
        .catch(() => false);
    },
    exchangeCodeForToken(code) {
      HTTP({
        method: 'post',
        url: 'admin/auth/callback',
        data: {
          code,
          user_id: sessionStorage.getItem('user'),
        },
        auth: false,
      })
        .then((response) => {
          sessionStorage.removeItem('user');
          // Set access token, this access token has additional scopes that can be used to get an access token for a user
          this.setAccessToken(response.data.data);
          window.location = '/';
        })
        .catch((e) => {
          // eslint-disable-next-line
          console.error(e);
          this.$bus.$emit('renderGlobalMessage', {
            message: e.message,
            type: 'error',
            title: 'Error!!!',
          });
        });
    },
  },
};
</script>

<style scoped>
.p-login {
  position: fixed;
  height: 100vh !important;
  width: 100vw !important;
  z-index: 10;
  top: 0;
  left: 0;
  margin-top: 0 !important;
  background: var(--signable-primary-1) !important;
  overflow: hidden;
}

.p-login__form {
  width: 100%;
  max-width: 280px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  padding: var(--spacing-small);
  box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.15);
  border: none;
  border-radius: 9px;
}

.p-login__form__logo {
  padding: var(--spacing-small);
  margin-bottom: var(--spacing-small);
  border-bottom: 1px solid var(--color-border);
}
</style>
